/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Mathematics20Inputs */

const en__field__enum_teachingsubjectinterest_subject_mathematics20 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Mathematics20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mathematics`)
};

const de__field__enum_teachingsubjectinterest_subject_mathematics20 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Mathematics20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mathematik`)
};

/**
* | output |
* | --- |
* | "Mathematics" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Mathematics20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_mathematics20 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Mathematics20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Mathematics20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_mathematics20(inputs)
	return de__field__enum_teachingsubjectinterest_subject_mathematics20(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_mathematics20 as "_field__enum_teachingSubjectInterest_SUBJECT_MATHEMATICS" }